export const MOBILE_RUNS_TABLE_LABELS = {
	CRITICAL_ISSUES: 'Critical Issues',
	TOTAL_ISSUES: 'Total Issues',
	DATE: 'Date',
	ACTIONS: 'Actions',
	VIEW_DETAILS: 'View Details',
	viewDetailsAria: (name: string) => `View details for ${name}`
} as const;
